import { z } from 'zod';
/**
 * Egyptian mobile numbers (see DECISIONS.md).
 * Accepted input: 01XXXXXXXXX, +201XXXXXXXXX, 00201XXXXXXXXX, 201XXXXXXXXX (spaces/dashes ignored).
 * Operator prefixes: 010 Vodafone, 011 Etisalat/e&, 012 Orange, 015 WE.
 * Stored form: E.164, e.g. +201001234567.
 */
const LOCAL_MOBILE = /^01[0125]\d{8}$/;
export function normalizeEgyptMobile(input) {
    const compact = input.replace(/[\s\-().]/g, '');
    let local = null;
    if (/^\+201[0125]\d{8}$/.test(compact))
        local = `0${compact.slice(3)}`;
    else if (/^00201[0125]\d{8}$/.test(compact))
        local = `0${compact.slice(4)}`;
    else if (/^201[0125]\d{8}$/.test(compact))
        local = `0${compact.slice(2)}`;
    else if (LOCAL_MOBILE.test(compact))
        local = compact;
    return local ? `+20${local.slice(1)}` : null;
}
/** +201001234567 -> 01001234567 (for display to Egyptian users). */
export function formatEgyptMobileLocal(e164) {
    return e164.startsWith('+20') ? `0${e164.slice(3)}` : e164;
}
export const EGYPT_MOBILE_ERROR = 'Must be an Egyptian mobile number: 11 digits starting with 010, 011, 012 or 015';
export const egyptMobileSchema = z.string().transform((value, ctx) => {
    const normalized = normalizeEgyptMobile(value);
    if (!normalized) {
        ctx.addIssue({ code: 'custom', message: EGYPT_MOBILE_ERROR });
        return z.NEVER;
    }
    return normalized;
});
//# sourceMappingURL=phone.js.map